<div class="modal-report-table">
    <div class="close-modal" (click)="activeModal.close('')">
        <img
            appImageSelector
            alt="mt-image"
            imageType="icon"
            imageKey="x-modal"
        />
    </div>
    <div class="title">{{ 'loops_details' | lang  | pascalcase}}</div>
    <div class="container">
        <app-main-table [tableConfig]="tableConfig"></app-main-table>
    </div>
</div>
